let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1S2jF")).then(() => parcelRequire('edwAF'));